import { render } from "./DataColumn.vue?vue&type=template&id=202ad4cf&scoped=true"
import script from "./DataColumn.vue?vue&type=script&lang=js"
export * from "./DataColumn.vue?vue&type=script&lang=js"

import "./DataColumn.vue?vue&type=style&index=0&id=202ad4cf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-202ad4cf"],['__file',"src/components/qywx/data/DataColumn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "202ad4cf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('202ad4cf', __exports__)) {
    api.reload('202ad4cf', __exports__)
  }
  
  module.hot.accept("./DataColumn.vue?vue&type=template&id=202ad4cf&scoped=true", () => {
    api.rerender('202ad4cf', render)
  })

}


export default __exports__